import React from "react";
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";

export const OrderSortHeader = ({ column, label, activeKey, direction, onSort, testId, className = "", align = "left" }) => {
  const active = activeKey === column;
  const nextDirection = active && direction === "asc" ? "descending" : "ascending";
  const currentDirection = direction === "asc" ? "ascending" : "descending";
  const Icon = active ? (direction === "asc" ? ArrowUp : ArrowDown) : ArrowUpDown;

  return (
    <th scope="col" aria-sort={active ? currentDirection : "none"}
      className={`p-3 ${className}`} data-testid={`column-header-${testId}`}>
      <button type="button" onClick={() => onSort(column)} data-testid={`sort-${testId}`}
        aria-label={`${label}${active ? `, sorted ${currentDirection}` : ""}. Sort ${nextDirection}`}
        title={`Sort ${label} ${nextDirection}`}
        className={`flex min-h-8 w-full items-center gap-1 rounded-sm uppercase text-inherit transition-colors hover:text-[var(--ink)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand)] ${align === "right" ? "justify-end text-right" : "text-left"} ${active ? "font-bold text-[var(--ink)]" : ""}`}>
        <span>{label}</span>
        <Icon size={12} aria-hidden="true" className="shrink-0" data-testid={`sort-indicator-${testId}`} />
      </button>
    </th>
  );
};